import Swiper from "swiper";
import { Navigation, A11y, Keyboard } from "swiper/modules";

export const init = function (callback) {
  let swiperContainers = document.querySelectorAll(".content-slider--7");

  swiperContainers.forEach(function (swiperContainer) {
    let cID = swiperContainer.getAttribute("id");
    let id = swiperContainer.querySelector(".swiper").getAttribute("id");
    let wrapper = swiperContainer.querySelector(".swiper-wrapper");
    let slideCount = swiperContainer.dataset.slides;
    let options = {
      slidesPerView: 1,
      breakpoints: {
        375: {
          slidesPerView: 2,
        },
        575: {
          slidesPerView: 3,
        },
        991: {
          slidesPerView: 4,
        },
        1199: {
          slidesPerView: slideCount ? parseInt(slideCount) : 5,
        },
      },
    };

    if (!slideCount) {
      options = { slidesPerView: "auto" };
    }

    let swiper = new Swiper(`#${id}`, {
      modules: [Navigation, Keyboard, A11y],
      ...options,
      speed: 500,
      loop: true,
      watchSlidesProgress: true,
      keyboard: { enabled: true },
      a11y: { enabled: true },
      on: {
        afterInit: function (swiper) {
          swiperContainer.classList.add("slider-init");
        },
        lock: function (swiper) {
          swiperContainer.classList.add("slider-lock");
          wrapper.classList.add("justify-content-center");
        },
        unlock: function (swiper) {
          swiperContainer.classList.remove("slider-lock");
          wrapper.classList.remove("justify-content-center");
        },
      },
    });

    document
      .querySelector(`#${cID} .arrow--next`)
      .addEventListener("click", function () {
        swiper.slideNext();
      });

    document
      .querySelector(`#${cID} .arrow--prev`)
      .addEventListener("click", function () {
        swiper.slidePrev();
      });
  });
};
